import React from 'react';
import Menu from './Menu';
import UserMenu from './UserMenu';
import { FRONTEND_ADMIN_URL } from '../../config';
import api from 'api';
import adminApi from '../admin/api';
import VERSION from '../../version';

const SCREEN_SIZE_SM = 768;

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSideBar = this.toggleSideBar.bind(this);
    this._sideBarCollapsed = false;
    this._sideBarMobileCollapsed = true;
  }
  componentWillReceiveProps(nextProps) {
    const previousUrl = this.props.location.pathname + this.props.location.search;
    const newUrl = nextProps.location.pathname + nextProps.location.search;
    if (newUrl !== previousUrl) {
      window.previousLocation = previousUrl;
    }
  }
  toggleSideBar(evt) {
    evt.preventDefault();
    // If desktop
    if (window.innerWidth > SCREEN_SIZE_SM - 1) {
      this._sideBarCollapsed = !this._sideBarCollapsed;
      document.body.classList.toggle('sidebar-collapse', this._sideBarCollapsed);
    } else {
      this._sideBarMobileCollapsed = !this._sideBarMobileCollapsed;
      document.body.classList.toggle('sidebar-open', !this._sideBarMobileCollapsed);
    }
  }

  render() {
    const isAdminUI = this.props.location.pathname.match(`^${FRONTEND_ADMIN_URL}`);
    return (
      <div className="wrapper">
        <header className="main-header">
          <a href={ isAdminUI ? FRONTEND_ADMIN_URL : '/' } className="logo">
            <span className="logo-mini"><b>{ isAdminUI ? 'ADMIN' : 'PMS' }</b></span>
            <span className="logo-lg"><b>{ isAdminUI ? 'ADMIN' : 'PMS' }</b></span>
          </a>

          <nav className="navbar navbar-fixed-top">
            <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button" onClick={ this.toggleSideBar }>
              <span className="sr-only">Toggle navigation</span>
            </a>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <UserMenu { ...this.props } api={ !isAdminUI ? api : adminApi } />
              </ul>
            </div>
          </nav>
        </header>

        <aside className="main-sidebar">
          <section className="sidebar">
            {
              !isAdminUI
                ? <Menu { ...this.props } />
                : null
            }
          </section>
          <section className="footer">
            version { VERSION }
          </section>
        </aside>

        { this.props.children }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/frontend/layout/Layout.jsx